export const SAVE_USER_INFO = 'save_user_info';// 保存用户信息
export const SAVE_USER_PHONE = 'save_user_phone';// 保存用户手机号
export const SAVE_COURSE_DATA = 'save_course_data';// 保存课程信息
export const SAVE_COURSE_SIMPLE_DATA = 'save_course_simple_data';// 保存课程信息
export const SAVE_COURSE_BUY_STATUS = 'save_course_buy_status';// 保存当前主产品购买状态
export const SAVE_COURSE_BUY_STATUS_FOR_COURSE_LIST = 'save_course_buy_status_for_course_list';// 保存当前主产品购买状态
export const SAVE_PRODUCT_SKU = 'save_product_sku';// 保存当前选择的sku
export const SAVE_CURRICULUM_DATA = 'save_curriculum_data';// 保存当前课程展示的课表
export const SAVE_CURRENT_ENV = 'set_current_env';// 保存当前环境值
export const CHANGE_LOGIN_POPUP_STATUS = 'change_login_popup_status'; // 登录弹窗显示控制
export const SAVE_ALL_ACVITITY = 'save_all_acvitity';// 保存产品详情页所有的活动信息
export const UPDATE_CURRENT_TIME = 'update_current_type';
export const SAVE_COURSE_BASE_DATA = 'save_course_base_data';// 保存课程基本信息（课程详情）
export const SAVE_ADDRESS_INFO = 'save_address_info';// 保存地址信息
export const SET_CURRENT_YEAR = 'set_current_year';// 设置选择考季
export const SAVE_ACTIONS_TYPE = 'set_actions_type'; // 设置登录
export const SAVE_COURSE_INFO = 'save_course_info'; // 保存公开课信息
export const SAVE_GROUP_BUY_DETAIL = 'save_group_buy_detail_vuex'; // 保存拼团详情
export const SET_ORDER_ADDRES = 'set_order_address'; // b站订单详情
